
    function toggleMenu(){document.getElementById('navMenu').classList.toggle('open')}
    document.querySelectorAll('nav a').forEach(a=>a.addEventListener('click',()=>document.getElementById('navMenu').classList.remove('open')))
    document.querySelectorAll('.faq-q').forEach(btn=>btn.addEventListener('click',()=>btn.parentElement.classList.toggle('open')))
    document.getElementById('bookingForm').addEventListener('submit',function(e){
      const selected=[...this.querySelectorAll('input[name="Services"]:checked')];
      if(!selected.length){
        e.preventDefault();
        alert('Please select at least one service.');
      }
    });
    document.getElementById('year').textContent=new Date().getFullYear();
  